<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoTrace' :class="{scrollHide: isShowTraceStoreBox}" ref="scrollBox">
    <div class="listBox">
      <div class="menuBox">
        <span @click="initQiehuanFun(5)" :class="{'badge-secondary':type===5,'badge-light':type!==5}" class="badge">@我</span>
        <span @click="initQiehuanFun(2)" :class="{'badge-secondary':type===2,'badge-light':type!==2}" class="badge">事件</span>
        <span @click="initQiehuanFun(6)" :class="{'badge-secondary':type===6,'badge-light':type!==6}" class="badge">回复我</span>
        <span @click="initQiehuanFun(4)" :class="{'badge-secondary':type===4,'badge-light':type!==4}" class="badge">批注</span>
        <span @click="initQiehuanFun(3)" :class="{'badge-secondary':type===3,'badge-light':type!==3}" class="badge">签到</span>
        <span @click="initQiehuanFun(1)" :class="{'badge-secondary':type===1,'badge-light':type!==1}" class="badge">全部</span>
      </div>

      <div class="timeline-item blue" :class="{red:app.cate==='2' || app.cate==='3' || app.cate==='4'}" v-for="(app,index) in data" :date-is="app.addtime_str" :key="index">
        <span class="title " v-if="app.cate==='3'"><span href="javascript:void(0);">{{app.userid_str}}</span> <i class="iconfont icon-youyou-"></i> 讲座签到</span>
        <span class="title " v-if="app.cate==='2'"><span href="javascript:void(0);">{{app.userid_str}}</span> <i class="iconfont icon-youyou-"></i> <span class="" href="javascript:void(0);">{{app.type}}</span></span>
        <span class="title" v-if="app.cate==='1'"><span href="javascript:void(0);">{{app.userid_str}}</span> <i class="iconfont icon-youyou-"></i> {{app.type}}</span>
        <span class="title " v-if="app.cate==='4'"><span href="javascript:void(0);">{{app.userid_str}}</span> <i class="iconfont icon-youyou-"></i> 批注</span>
        <div class="huifu waiceng">
          <span v-html="app.contents" class="hovers" @click="showFromFun(true,3,{trace_id:app.str,pid:app.str,puid:app.userid,puid_str:app.userid_str,contents:app.contents,type:app.type,path:app.path,cate:app.cate,addtime_str3:app.addtime_str3})" :class="{red:app.red}"></span>
          <span class="content">{{app.usercalls_str}}</span>
          <div class="huifu" v-if="app.child.length!==0">
            <ul>
              <li v-for="(apps,indexs) in app.child" :key="indexs">
                {{apps.addtime_str2}} - {{apps.userid_str}} 回复 {{apps.puid_str}}
                ：<span class="hovers" @click="showFromFun(true,3,{trace_id:apps.str,pid:app.str,puid:apps.userid,puid_str:apps.userid_str,contents:apps.contents,type:apps.type,path:apps.path,cate:apps.cate,addtime_str3:apps.addtime_str3})" :class="{red:apps.red}" v-html="apps.contents"></span></li>
            </ul>
          </div>
          <div class="msg" style="margin: 0;" v-if="app.cate==='2' && app.path.length!==0 || app.path.length!==0">
            <div v-for="(pathVal,pathKey) in app.path" :key="pathKey+'efawe'">
              <span v-if="(pathVal).substring((pathVal).lastIndexOf('.')+1)==='jpg' || (pathVal).substring((pathVal).lastIndexOf('.')+1)==='png' || (pathVal).substring((pathVal).lastIndexOf('.')+1)==='jpeg'" @click="toPcFun" class="badge badge-info"><i class="iconfont icon-file"></i> 打开图片</span>
              <span v-if="(pathVal).substring((pathVal).lastIndexOf('.')+1)==='pdf'" @click="toPcFun" class="badge badge-info"><i class="iconfont icon-file"></i> 打开PDF</span>
              <span v-if="(pathVal).substring((pathVal).lastIndexOf('.')+1)==='zip' || (pathVal).substring((pathVal).lastIndexOf('.')+1)==='rar'" @click="toPcFun" class="badge badge-info"><i class="iconfont icon-xiazai-"></i> 下载压缩包</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!is_empty">
        <div v-if='isLoading  && !isSearchLoading' class='dynamicMessage'>
          <i class='iconfont icon-jiazai xuanzhuan'></i>
        </div>
        <div v-if='isNodata' class='dynamicMessage'>
          — 没有更多了 —
        </div>
        <div v-if='isError' class='dynamicMessage'>
          — 请求失败 —
        </div>
      </div>
      <div class="emptyBox" v-if="is_empty && data.length===0">
        <i class="iconfont icon-kong"></i>
      </div>

    </div>

    <div v-if="isShowTraceStoreBox" class="traceStoreBoxModel" @click.self="showFromFun(false,1)">
      <div class="traceStoreBox" v-if="isTraceType===1">
        <div class="xuanzeBox mb-3">
          <div v-if="pizhuVal.length===0">
            <multiselect v-model="typeVal" track-by="name" label="name" placeholder="维护类型" :options="typeArr" :searchable="false"  :show-labels="false">
              <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
            </multiselect>
          </div>
          <div>
            <multiselect v-model="informVal" :hideSelected="true" :options="informArr" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="@同事" label="name" track-by="id">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="informVal.length &amp;&amp; !isOpen">{{informValStr}}</span>
              </template>
            </multiselect>
          </div>
          <div class="last">
            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="gridCheck" :value="true" v-model="pizhuVal">
                <label class="form-check-label" for="gridCheck">
                  批注
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="textareaBox mb-3">
          <textarea placeholder="内容提交前将自动缓存于本地" v-on:input="huancunFun(1)" class="form-control"  aria-label="With textarea" v-model="contentVal"></textarea>
        </div>
        <div class="anniuBox">
          <button type="button" @click="showFromFun(true,2)" class="btn btn-secondary btn-round">事件&节点</button>
          <button type="button" @click="submitFun()" class="btn btn-success btn-round"><i v-if="isSubmitLoading" class='iconfont icon-jiazai xuanzhuan'></i> 立即跟进</button>
        </div>
      </div>
      <div class="traceStoreBox" v-if="isTraceType===2">
        <div class="biaodanBox mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">事件标题</span>
            </div>
            <input type="text" class="form-control" v-model="titleVal">
          </div>
        </div>
        <div class="biaodanBox mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">发生时间</span>
            </div>
            <input readonly ref="timesNode" onclick="WdatePicker({isShowClear:true,readOnly:true,dateFmt:'yyyy-MM-dd'})" type="text" class="form-control">
          </div>
        </div>
        <div class="biaodanBox mb-3">
          <uploader :options="options" @file-added="onFileAdded" @file-success="onFileSuccess" @file-error="onFileError" @file-removed="fileRemoved">
            <uploader-btn class="clearCss" :attrs="attrs">
              <div class="uploadBox">
                <div :class="{'text-success':!!filepathTitle}" v-if="!isUploadLoading">{{filepathTitle?filepathTitle:'【上传附件】'}}</div>
                <div v-else><i class='iconfont icon-jiazai xuanzhuan'></i> 上传中···</div>
              </div>
            </uploader-btn>
          </uploader>
        </div>
        <p class="content">注：PDF / 压缩包</p>
        <div class="textareaBox mb-3">
          <textarea placeholder="内容提交前将自动缓存于本地" v-on:input="huancunFun(2)" class="form-control" aria-label="With textarea" v-model="contentVal"></textarea>
        </div>
        <div class="anniuBox">
          <button type="button" @click="showFromFun(true,1)" class="btn btn-secondary btn-round">普通跟进</button>
          <button type="button" @click="submitFun()" class="btn btn-success btn-round"><i v-if="isSubmitLoading" class='iconfont icon-jiazai xuanzhuan'></i> 执行记录</button>
        </div>
      </div>
      <div class="traceStoreBox" v-if="isTraceType===3">
        <div class="textareaBox mb-3">
          <textarea class="form-control" :placeholder="'回复：'+puid_str" v-model="contentVal"></textarea>
        </div>
        <div class="anniuBox">
          <button v-if="rbacCrmTraceModify" type="button" @click="showFromFun(true,4)" class="btn btn-secondary btn-round">修改</button>
          <button v-if="rbacCrmTraceDel && !rbacCrmTraceDestroy" @click="delTraceInfo(trace_id,false)" type="button" class="btn btn-danger btn-round"><i v-if="isSubmitDelLoading" class='iconfont icon-jiazai xuanzhuan'></i> 删除</button>
          <button v-if="rbacCrmTraceDestroy" @click="delTraceInfo(trace_id,true)" type="button" class="btn btn-danger btn-round"><i v-if="isSubmitDelLoading" class='iconfont icon-jiazai xuanzhuan'></i> 销毁</button>
          <button type="button" @click="submitFun()" class="btn btn-success btn-round float-left"><i v-if="isSubmitLoading" class='iconfont icon-jiazai xuanzhuan'></i> 立即回复</button>
        </div>
      </div>
      <div class="traceStoreBox" v-if="isTraceType===4">
        <div v-if="cate==='2'" class="biaodanBox mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">事件标题</span>
            </div>
            <input type="text" class="form-control" v-model="titleVal">
          </div>
        </div>
        <div v-if="cate==='2'" class="biaodanBox mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">发生时间</span>
            </div>
            <input v-model="addtime_str3" readonly ref="timesNode" onclick="WdatePicker({isShowClear:true,readOnly:true,dateFmt:'yyyy-MM-dd'})" type="text" class="form-control">
          </div>
        </div>
        <div v-if="cate==='2'" class="biaodanBox mb-3">
          <uploader :options="options" @file-added="onFileAdded" @file-success="onFileSuccess" @file-error="onFileError" @file-removed="fileRemoved">
            <uploader-btn class="clearCss" :attrs="attrs">
              <div class="uploadBox">
                <div :class="{'text-success':!!filepathTitle}" v-if="!isUploadLoading">{{filepathTitle?'附件已上传（若修改请重新上传）':'【上传附件】'}}</div>
                <div v-else><i class='iconfont icon-jiazai xuanzhuan'></i> 上传中···</div>
              </div>
            </uploader-btn>
          </uploader>
        </div>
        <p class="content">注：PDF / 压缩包</p>
        <div class="textareaBox mb-3">
          <textarea class="form-control" v-model="contentVal"></textarea>
        </div>
        <p class="content">注：只可修改自己的维护</p>
        <div class="anniuBox">
          <button type="button" @click="showFromFun(true,3,{trace_id:trace_id,pid:pid,puid:puid,puid_str:puid_str,contents:contents,type:type,path:path,cate:cate,addtime_str3:addtime_str3})" class="btn btn-secondary btn-round float-left">返回</button>
          <button type="button" @click="submitFun()" class="btn btn-success btn-round"><i v-if="isSubmitLoading" class='iconfont icon-jiazai xuanzhuan'></i> 确认修改</button>
        </div>
      </div>
    </div>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
    <span v-if="!isShowTraceStoreBox && info.type!=='1' && info.is_del!=='1'" @click="showFromFun(true,1)" class="tianjia btn btn-success btn-round">维护</span>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/types';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import crmChanceMix from '@/util/mix/localUserMix';
import commons from '../../../util/commons';

export default {
  name: 'CommonClientinfoTrace',
  props: ['token', 'info', 'rootUnitIsSuccessFun'],
  mixins: [crmChanceMix],
  data() {
    return {
      traceNumber: 0,

      isUploadLoading: false,
      filepath: '',
      filepathTitle: '',
      // 跟进类型
      typeVal: null,
      titleVal: '',
      // @人
      informVal: [],
      // 批注
      pizhuVal: [],
      // 跟进内容
      contentVal: '',
      // 类型
      typeArr: [
        { id: 1, name: '电话回访' },
        { id: 2, name: '微信沟通' },
        { id: 3, name: '公司面谈' },
        { id: 4, name: '活动到访' },
        { id: 5, name: '上门拜访' },
      ],
      // @用户
      informArr: [
        { id: 1, name: '张三' },
        { id: 2, name: '李四' },
        { id: 3, name: '王二麻' },
        { id: 4, name: '小红' },
        { id: 5, name: '小兰' },
      ],

      type: 1,
      // 是否显示跟进表单
      isShowTraceStoreBox: false,
      // 事件节点或者跟进表单
      isTraceType: 1,
      // 跟进id
      trace_id: '',
      // 父级跟进
      pid: '',
      // 回复何人
      puid: '',
      puid_str: '',
      // 触发的内容
      contents: '',
      runNumber: 0,

      isSubmitLoading: false,
      isSubmitDelLoading: false,

      // 分页
      data: [], // 数据队列
      allPage: 0, // 总页数
      allNumber: 0, // 总页数
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      diffuser: '',
      // 加载中
      isSearchLoading: true,


      attrs: {
        accept: 'application/x-gzip,application/zip,application/rar,application/x-tar,application/pdf',
      },
    };
  },
  computed: {
    ...mapGetters({
      localUser: types.GET_LOCALUSER,
    }),
    options() {
      return {
        target: process.env.IMAGE_UPLOAD_URL,
        testChunks: false,
        singleFile: true,
        chunkSize: 200 * 1024 * 1024,
        fileParameterName: 'UploadFormfile[imgFile]',
        query: {
          dir: 'event',
        },
        headers: {
          Authorization: this.localUser.token,
        },
      };
    },
    // 选中的类型
    informValStr() {
      const arr = [];
      this.informVal.forEach((app) => {
        arr.unshift(app.name);
      });
      return `@${arr.join(',')}`;
    },
    // 条件
    whereJson() {
      return {
        page: this.page,
        type: this.type,
        token: this.token,
      };
    },
    submitData() {
      let arr;
      if (this.isTraceType === 1) {
        // 跟进
        arr = {
          newData: true, // 取消24小时
          token: this.token,
          type: this.typeVal ? this.typeVal.name : '',
          usercalls: commons.whereArrStr(this.informVal),
          contents: this.contentVal,
          pizhu: !!this.pizhuVal.length,
          cate: 1,
          isTraceType: this.isTraceType,
        };
      } else if (this.isTraceType === 2) {
        // 事件节点
        arr = {
          newData: true, // 取消24小时
          token: this.token,
          type: this.titleVal,
          times: this.$refs.timesNode.value,
          contents: this.contentVal,
          cate: 2,
          isTraceType: this.isTraceType,
          filepath: this.filepath,
        };
      } else if (this.isTraceType === 3) {
        // 回复
        arr = {
          token: this.token,
          pid: this.pid,
          puid: this.puid,
          contents: this.contentVal,
          cate: 1,
          isTraceType: this.isTraceType,
        };
      } else {
        arr = {
          str: this.trace_id,
          contents: this.contentVal,
          isTraceType: this.isTraceType,
        };
        // 修改
        if (this.cate === '2') {
          arr.type = this.titleVal;
          arr.filepath = this.filepath;
          arr.times = this.$refs.timesNode.value;
        }
      }
      arr.runNumber = this.runNumber;
      return arr;
    },
  },
  methods: {
    toPcFun() {
      this.$message.showMsgBox({
        type: 'warning',
        content: '附件相关资料需前往PC端打开',
      });
    },
    // eslint-disable-next-line camelcase
    delTraceInfo(trace_id, bool) {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      this.isSubmitDelLoading = true;
      // 更新
      this.runNumber += 1;
      resultCommons.apiCrmTracedel(this, { token: this.trace_id, bool }).then((ob) => {
        EventBus.$emit('globalZhezhaoBoxFun', false);
        this.isSubmitLoading = false;
        if (ob.state === 200) {
          // this.data.forEach((app, index) => {
          //   if (app.str === ob.data.trace_id) {
          //     // this.data[index] = info;
          //     console.log(index, 'xxxxxxxxxxxxxxxxxxxxxx');
          //   }
          // });
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.data.length; i++) {
            console.log(i, 'aaaaaaaaaaaaaaaaaaaaaa');
            const info = this.data[i];
            if (info.str === ob.data.trace_id) {
              this.data.splice(i, 1);
              break;
            }
            let duan = false;
            // eslint-disable-next-line no-plusplus
            for (let j = 0; j < info.child.length; j++) {
              console.log(j, 'bbbbbbbbbbbbbbbbbbbbb');
              const infos = this.data[i].child[j];
              if (infos.str === ob.data.trace_id) {
                this.data[i].child.splice(j, 1);
                duan = true;
                break;
              }
            }
            if (duan) {
              break;
            }
          }
          // this.data.filter((app, index) => app.str === ob.data.trace_id);
          // 加载中
          this.isSubmitDelLoading = false;
          // 隐藏框
          this.isShowTraceStoreBox = false;
          // 框类型
          this.isTraceType = 1;
          // 成功
          this.$message.showMsgBox({
            type: 'success',
            content: ob.message,
          });
          // 更新根目录
          this.rootUnitIsSuccessFun(3, ob.data.crm_data_id);
        } else {
          // 警告失败
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message,
          });
          // 加载中
          this.isSubmitDelLoading = false;
        }
      });
    },
    huancunFun(type) {
      const key = `${this.info.id}.${this.localUser.phone}.${type}`;
      commons.saveTodos(key, { content: this.contentVal });
    },
    onFileAdded(file) {
      // 判断文件大小
      const size = file.file.size;
      if (size > process.env.IMAGE_UPLOAD_SIZE) {
        file.pause();
        this.$message.showMsgBox({
          type: 'success',
          content: '文件过大',
        });
      }
    },
    onFileSuccess(rootFile, file, response, chunk) {
      // 上传选择后
      const result = JSON.parse(response);
      if (result.state === 200) {
        this.filepath = result.data.path;
        this.filepathTitle = result.data.name;
        this.$message.showMsgBox({
          type: 'success',
          content: '上传成功',
        });
      } else {
        this.$message.showMsgBox({
          type: 'error',
          content: result.message,
        });
      }
      this.isUploadLoading = false;
    },
    onFileError(file) {
      console.log(file, 'onFileError');
      // 上传选择后
      this.$message.showMsgBox({
        type: 'error',
        content: '上传失败',
      });
    },
    fileRemoved(file) {
      console.log(file, 'fileRemoved');
    },
    // 弹出跟近框
    showFromFun(bool, isTraceType = 1, ob = {}) {
      console.log(this.info.type);
      this.stateVal = { id: 1, name: '有效沟通' };
      if (this.info.type !== '1' && this.info.is_del !== '1') {
        if (isTraceType === 3 || isTraceType === 4) {
          // 只有回复才重置
          if (isTraceType === 3) {
            this.trace_id = ob.trace_id;
            this.pid = ob.pid;
            this.puid = ob.puid;
            this.puid_str = ob.puid_str;
            this.contents = ob.contents;
            this.type = ob.type;
            // 文件
            this.filepath = ob.path;
            this.filepathTitle = ob.path;
            this.path = ob.path;
            this.addtime_str3 = ob.addtime_str3;
            // 内容
            this.contentVal = '';
            // 标题
            this.titleVal = '';
            // 类型
            this.cate = ob.cate;
            this.saveTimes = ob.addtime_str3;
          }
          if (isTraceType === 4) {
            // 修改
            let contents = this.contents;
            contents = contents.replace(/<br>/g, '\r\n');
            // eslint-disable-next-line no-useless-escape
            contents = contents.replace(/&nbsp;/g, ' ');
            this.contentVal = contents;
            // 标题
            this.titleVal = this.type;
          }
        } else {
          this.filepathTitle = '';
          this.filepath = '';
          this.pid = '';
          this.puid = '';
          this.puid_str = '';
          this.contents = '';
          this.typeVal = null;
          this.titleVal = '';
          this.informVal = [];
          this.pizhuVal = [];
          this.contentVal = '';
          if (this.$refs.timesNode) {
            this.$refs.timesNode.value = '';
          }
          if (bool) {
            const key = `${this.info.id}.${this.localUser.phone}.${isTraceType}`;
            const result = commons.readTodos(key);
            if (result.content !== undefined) {
              this.contentVal = result.content;
            }
          }
        }
        this.isShowTraceStoreBox = bool;
        this.isTraceType = isTraceType;
      }
    },
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      }
    },
    // 初始化个人的
    initData(reload = false) {
      if (reload) {
        this.data = [];
        this.allPage = 0;
        this.page = 1;
        this.allNumber = 0;
        this.is_empty = false; // 是否为空数据(没有任何数据)
        this.isNodata = false; // 没有更多了
        this.isLoading = false; // 是否请求中
        this.isError = false; // 请求失败
        this.isSearchLoading = true; // 悬浮加载中
      }
      return resultCommons.apiCrmTrace(this, this.whereJson, reload).then((ob) => {});
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = node.scrollHeight - node.scrollTop - node.clientHeight <= 150;
        console.log(bottomOfWindow);
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          this.initData();
        }
      };
    },
    // 切换模式
    initQiehuanFun(type) {
      if (this.type !== type) {
        this.type = type;
        // 初始化
        this.initData(true).then((app) => {
          this.isSearchLoading = false;
        });
      }
    },
    submitFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      this.isSubmitLoading = true;
      this.runNumber += 1;
      resultCommons.apiCrmTracestore(this, this.submitData).then((ob) => {
        console.log(ob);
        EventBus.$emit('globalZhezhaoBoxFun', false);
        this.isSubmitLoading = false;
        if (ob.state === 200) {
          const info = ob.data.info;
          if (ob.data.type === 'join') {
            this.data.unshift(info);
            // 如果是加入则删除本地缓存
            if (this.isTraceType === 1 || this.isTraceType === 2) {
              const key = `${this.info.id}.${this.localUser.phone}.${this.isTraceType}`;
              commons.saveTodos(key, null);
            }
          } else {
            this.data.forEach((app, index) => {
              if (app.str === info.str) {
                this.data[index] = info;
              }
            });
          }
          this.isShowTraceStoreBox = false;
          this.isTraceType = 1;
          this.$message.showMsgBox({
            type: 'success',
            content: ob.message,
          });
          // 更新根目录
          this.rootUnitIsSuccessFun(3, ob.data.dataArrStr);
        } else {
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message,
          });
        }
      });
    },
  },
  components: {
    Multiselect,
  },
  created() {
    // 初始化
    this.initData().then((app) => {
      this.isSearchLoading = false;
      resultCommons.apiCrmTraceLabel(this, { type: 12 }).then((ob) => {
        if (ob.state === 200) {
          this.typeArr = ob.data;
        } else {
          // 请求失败
          this.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
        }
      });
      resultCommons.apiUserZaizhi(this, {}).then((ob) => {
        if (ob.state === 200) {
          this.informArr = ob.data.filter(app => app.id !== this.diffuser);
        } else {
          // 请求失败
          this.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
        }
      });
    });
  },
  mounted() {
    // 创建事件
    this.scroll(this, this.$refs.scrollBox);
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoTrace{
  flex: 1;
  overflow-y: scroll;
  padding: 15px;
  padding-left: 25px;
  background: #FAFAFA;
  .timeline-item::before{
    font-size: 12px;
  }
  div.traceStoreBoxModel{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.1);
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    div.traceStoreBox{
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
      padding: 30px 15px;
      background: #FFFFFF;
      div.xuanzeBox{
        display: flex;
        flex-direction: row;
        div{
          flex: 2;
          margin-right: 15px;
        }
        div.last{
          display: flex;
          align-items: center;
          margin: 0;
          flex: none;
          width: 80px !important;
          div.form-group{
            margin: 0;
            .form-check{
              margin: 0;
            }
          }
        }
      }
      div.biaodanBox{
        .custom-file-label::after{
          content: '选择附件';
        }
      }
      div.textareaBox{
        textarea{
          height: 100px;
          border-radius: 5px;
        }
      }
      div.anniuBox{
        text-align: right;
      }
    }
  }
  span.tianjia{
    position: absolute;
    display: inline-block;
    width: 90px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-bottom: 20px;
    text-align: center;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  }
  div.listBox{
    min-height:100%;
    display: flex;
    flex-direction: column;
    div.menuBox{
      text-align: right;
      margin: 0;
      margin-bottom: 10px;
      .badge{
        cursor: pointer;
        font-size: 14px;
        font-weight: 300;
        margin: 0;
        &.badge-light{
          color: #FFFFFF;
          background: #9FA5AA;
        }
      }
    }
    .timeline-item{
      padding: 2.8em 2em 2em;
      padding-bottom: 0.5rem;
      padding-right: 0;
      div.msg{
        margin: 5px 0;
        margin-bottom: 0;
        color: #666666;
        font-size: 14px;
        div{
          display: inline-block;
          margin-right: 10px;
          &:last-child{
            margin: 0;
          }
          a{
            display: inline-block;
            margin: 0;
          }
          a{
            i{
              font-size: 12px;
            }
          }
        }
      }

      div.huifu {
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        color: #999999;
        border-radius: 5px;
        padding: 0.4rem 0.6rem;
        margin-top: 6px;
        //font-size: 13px;
        line-height: 1.5em;

        &.waiceng {
          border-color: rgba(0, 0, 0, 0.1);
        }

        span.hovers {
          font-size: 12px;
          display: block;
          color: #666666;
          cursor: pointer;
          word-wrap: break-word;
          color: #000000;

          &.red {
            color: #DC3545;
          }

          &:hover {
            color: #2937FD;
          }
        }
      }

      .title{
        font-family: 'gilroy-semibold';
        span{
          text-transform: capitalize;
        }
      }
      &::after{
        top: 1.2em;
      }
    }
    div.emptyBox{
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      i{
        font-size: 70px;
        color: rgba(0,0,0,0.1);
      }
    }
  }
  .timeline-item::before {
    top: 0.8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/trace.vue